import { render, staticRenderFns } from "./serveOrderList.vue?vue&type=template&id=33efd753&"
import script from "./serveOrderList.vue?vue&type=script&lang=js&"
export * from "./serveOrderList.vue?vue&type=script&lang=js&"
import style0 from "./serveOrderList.vue?vue&type=style&index=0&id=33efd753&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports